import type {
  BusinessCorporationType,
  CollectedDataOption,
  ModernBusinessDecryptResponse,
} from '@onefootprint/request-types';

export const CORPORATION_TYPE_OPTIONS: { value: BusinessCorporationType }[] = [
  { value: 'c_corporation' },
  { value: 's_corporation' },
  { value: 'b_corporation' },
  { value: 'llc' },
  { value: 'llp' },
  { value: 'partnership' },
  { value: 'sole_proprietorship' },
  { value: 'non_profit' },
  { value: 'trust' },
  { value: 'agent' },
];

// Business data identifiers for basic data
export const BUSINESS_BASIC_FIELDS: (keyof ModernBusinessDecryptResponse)[] = [
  'business.name',
  'business.dba',
  'business.tin',
  'business.corporation_type',
  'business.website',
  'business.phone_number',
] as const;

// Collected data options that correspond to basic business data
export const BASIC_DATA_CDOS: CollectedDataOption[] = [
  'business_name',
  'business_tin',
  'business_corporation_type',
  'business_phone_number',
  'business_website',
] as const;
